/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Realitymix_SubtitleInputs */

const cs_realitymix_subtitle = /** @type {(inputs: Realitymix_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML-RPC import pro kancelářské RK. Stejný tvar údajů jako Sreality (client id, software key, heslo).`)
};

const en_realitymix_subtitle = /** @type {(inputs: Realitymix_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML-RPC import for the office RK. Same credential shape as Sreality (client id, software key, password).`)
};

/**
* | output |
* | --- |
* | "XML-RPC import for the office RK. Same credential shape as Sreality (client id, software key, password)." |
*
* @param {Realitymix_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const realitymix_subtitle = /** @type {((inputs?: Realitymix_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Realitymix_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_realitymix_subtitle(inputs)
	return cs_realitymix_subtitle(inputs)
});